export const SET_FILTERS_DATA = "setFiltersData";
export const SET_SKIP_ADDING_WAREHOUSE = "setSkipAddingWarehouse";
export const SET_MAX_SELECTABLE_DAYS = "setMaxSelectableDays";
export const SET_OLDER_THAN_3MONTH = "setIsDataOlderThan3months";

const state = {
  filters_data: {},
  skipAddingWarehouse: false,
  maxSelectableDays: 30,
  isDataOlderThan3months: 30,
};

const getters = {
  getFiltersData(state) {
    return state.filters_data;
  },
  getSkipAddingWarehouse(state) {
    return state.skipAddingWarehouse;
  },
  getMaxSelectableDays(state) {
    return state.maxSelectableDays;
  },
  getIsDataOlderThan3months(state) {
    return state.isDataOlderThan3months;
  },
};

const mutations = {
  [SET_OLDER_THAN_3MONTH](state, isDataOlderThan3months) {
    state.isDataOlderThan3months = isDataOlderThan3months;
  },
  [SET_MAX_SELECTABLE_DAYS](state, maxSelectableDays) {
    state.maxSelectableDays = maxSelectableDays;
  },
  [SET_SKIP_ADDING_WAREHOUSE](state, skipAddingWarehouse) {
    state.skipAddingWarehouse = skipAddingWarehouse;
  },
  [SET_FILTERS_DATA](state, filters_data) {
    state.filters_data = filters_data;
  },
};

export default {
  state,
  mutations,
  getters,
};
